/**
 * Query Parameter Helper
 * 
 * Builds URL query strings from parameter objects.
 * Filters out undefined/null values and handles arrays consistently.
 * 
 * @example
 * withQuery('/api/workers', { page: 1, status: 'active', tags: ['a', 'b'] })
 * // Returns: '/api/workers?page=1&status=active&tags=a&tags=b'
 */

export function withQuery(path: string, params?: Record<string, any>): string {
  if (!params || Object.keys(params).length === 0) {
    return path;
  }

  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    // Skip undefined and null
    if (value === undefined || value === null) {
      continue;
    }

    // Handle arrays: use repeated keys (a=1&a=2)
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null) {
          searchParams.append(key, String(item));
        }
      }
      continue;
    }

    // Handle booleans and numbers: convert to string
    searchParams.append(key, String(value));
  }

  const queryString = searchParams.toString();
  return queryString ? `${path}?${queryString}` : path;
}
